<template>
  <div v-if="message">
    <slot v-bind:message="message">
      <span class="invalid-feedback d-block" role="alert"><strong>{{ message }}</strong></span>
    </slot>
  </div>
</template>

<script>

export default {
  name: 'ErrorComponent',
  components: {},
  props: {
    field: String,
    errors: Object,
  },
  data() {
    return {};
  },
  computed: {
    message: function () {
      if (this.errors && this.errors[this.field]) {
        return this.errors[this.field][0];
      }

      return null;
    }
  },
  methods: {},
  mounted() {
  }
};
</script>

<style scoped>

</style>
